import { Grid2Props as GridProps, Unstable_Grid2 as Grid } from "@mui/material";
import { PropsWithChildren } from "react";

/**
 * @deprecated Replaced by SenecNestedGrid component
 *
 * NestedGrid used to structure content with a spacing of 24px for sm and 16px for xs screensize.
 *
 * - The "disableEqualOverflow" Flag is set true, so the content is oriented in the lower right corner and is not centered.
 * - Based on MUI Grid v2: https://mui.com/material-ui/react-grid2/
 * - MUI Spacing based on 8px scaling factor: https://mui.com/material-ui/customization/spacing/
 */
export const NestedGrid = (props: PropsWithChildren<GridProps>) => {
    return (
        <Grid container disableEqualOverflow columns={{ xs: 6, sm: 8, md: 12 }} spacing={{ xs: 2, sm: 3 }} p={0} {...props}>
            {props.children}
        </Grid>
    );
};
